RivalIQ.apps.Share.module('controller', function (controller, App, Backbone, Marionette, $, _) {

    'use strict';

    const Controller = Marionette.Controller.extend({
        start: function (options) {

            const me = this;

            me.showBody(options);
            me.showSignup(options);
            me.showCompanies(options);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.V3ViewedClonePage, {
                landscapeId: options.landscapeId
            });
        },
        showBody: function (options) {

            new App.views.Body({
                el: '#acceptLandscape',
                model: new Backbone.Model(options)
            }).render();
        },
        showSignup: function (options) {

            const config = _.extend({
                el: '#signupForm'
            }, _.pick(options || {}, 'uuid', 'agid', 'scid'));

            const signupForm = new App.views.Signup(config);
            signupForm.render();
        },
        showCompanies: function (options) {

            let companies = _.sortBy(options.landscapeCompanies, 'name');
            const focusCompany = _.find(companies, {
                id: options.focusCompanyId
            });
            focusCompany.redacted = false;

            // leave room for focus company
            const maxAvailCompanies = options.maxNewCompanies - 1;
            const availableCompanies = _.map(_.without(companies, focusCompany), function (company, idx) {
                company.redacted = !options.loggedIn && options.landscapeIsAuditable && (idx >= maxAvailCompanies);
                return company;
            });

            companies = [focusCompany].concat(availableCompanies);

            new App.views.LandscapeCompanyTiles({
                el: '.landscape-company-tiles',
                collection: new Backbone.Collection(companies)
            }).render();
        }
    });

    controller.addInitializer(function (options) {

        const controller = new Controller();
        controller.start(options);
    });

});
